import React from "react";

import { makeStyles, createStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import clsx from "clsx";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import HighlightOffIcon from "@material-ui/icons/HighlightOffOutlined";

const useStyles = makeStyles((theme) =>
    createStyles({
        closeIcon: {
            position: "absolute",
            right: 5,
            top: 5,
            color: "#a9a6a6",
            cursor: "pointer",
            width: "20px",
            height: "20px",
            "&:hover": {
                color: "gray",
            },
        },
        dialogContent: {
            padding: theme.spacing(3),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(2),
            },
        },
        paper: {
            borderRadius: "20px",
            padding: theme.spacing(1),
        },
        actionBtn: {
            boxSizing: "border-box",
            borderRadius: "30px",
            fontWeight: 700,
            textTransform: "unset",
        },
        cancelBtn: {
            color: "#6D6D6D",
            borderColor: "#D0D0D0",
            "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
                borderColor: "#B0B0B0",
            },
        },
        dangerBtn: {
            backgroundColor: theme.palette.error.main,
            color: "#fff",
            "&:hover": {
                backgroundColor: theme.palette.error.dark,
            },
        },
        actionsWrapper: {
            padding: "0 24px 24px 24px",
        },
        closeIconWrapper: {
            position: "relative",
        },
    })
);

const Modal = (props: any) => {
    const classes = useStyles();

    return (
        <Dialog
            open={props.open}
            onClose={() => props.onClose()}
            className={classes.paper}
            classes={{ paper: classes.paper }}
            maxWidth="lg"
            disableBackdropClick={props.disableBackdropClick}
        >
            {props.hideActions && (
                <div className={classes.closeIconWrapper}>
                    <HighlightOffIcon className={classes.closeIcon} onClick={() => props.onClose()} />
                </div>
            )}
            <DialogContent className={classes.dialogContent}>{props.children}</DialogContent>
            <DialogActions
                classes={{ root: classes.actionsWrapper }}
                style={{ display: props.hideActions ? "none" : "" }}
            >
                <Button
                    onClick={props.onClose}
                    variant="outlined"
                    className={clsx(classes.actionBtn, classes.cancelBtn)}
                >
                    Cancel
                </Button>
                {props.displaySaveButton !== false && (
                    <Button
                        onClick={props.handleConfirm}
                        color={props.danger ? "default" : "primary"}
                        variant="contained"
                        className={clsx(classes.actionBtn, { [classes.dangerBtn]: props.danger })}
                    >
                        {props.confirmLabel || (props.danger ? "Delete" : "Save")}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default Modal;
